import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { ShieldOff } from 'lucide-react';

const NaoAutorizadoPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, isPaciente } = useContext(AuthContext);

  const handleVoltar = () => {
    if (!isAuthenticated) {
      navigate('/login');
    } else if (isAdmin) {
      navigate('/admin');
    } else if (isPaciente) {
      navigate('/meu-painel');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 w-full max-w-sm text-center">
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
          <ShieldOff className="w-7 h-7 text-red-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Acesso Negado</h2>
        <p className="text-sm text-gray-500 mb-7">
          Você não tem permissão para acessar esta página.
        </p>
        <button
          onClick={handleVoltar}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-xl font-medium text-sm transition-colors"
        >
          Voltar
        </button>
      </div>
    </div>
  );
};

export default NaoAutorizadoPage;